import { MaskLine, Reveal } from "./Reveal";

const STATS = [
  { value: "1969", label: "røtter helt tilbake til" },
  { value: "5", label: "fagfelt under ett tak" },
  { value: "20+", label: "ledende leverandører" },
  { value: "Hele", label: "Midt-Norge dekket" },
];

export const OmOss = () => (
  <section id="om-oss" className="bg-paper py-24 sm:py-32" data-testid="om-oss-section">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-8">
      <div className="grid grid-cols-12 gap-8">
        <div className="col-span-12 lg:col-span-5">
          <Reveal>
            <span className="font-oswald uppercase text-xs tracking-[0.3em] text-redx">Om oss</span>
          </Reveal>
          <h2 className="font-oswald font-bold uppercase tracking-tight leading-[0.9] text-5xl sm:text-7xl mt-4 text-ink">
            <MaskLine>Din partner</MaskLine>
            <MaskLine delay={0.1}>for proff-</MaskLine>
            <MaskLine delay={0.2}>kjøkken</MaskLine>
          </h2>
        </div>
        <div className="col-span-12 lg:col-span-7 lg:pt-4">
          <Reveal delay={0.2}>
            <p className="text-xl sm:text-2xl text-ink/80 leading-relaxed">
              Trøndelag Storkjøkkensenter AS er en av de <span className="text-redx">eldste aktørene</span> i storkjøkkenmarkedet i Midt-Norge, med røtter helt tilbake til 1969. Vi leverer alt av utstyr til alle typer kjøkken og vaskeri — kombinert med en stor og erfaren serviceavdeling, og er stolt Electrolux Professional-sertifisert partner.
            </p>
            <p className="text-ink/60 leading-relaxed mt-6 max-w-2xl">
              Fra prosjektering og leveranse til montasje og service følger vi deg gjennom hele løpet. Ett telefonnummer, ett kontaktpunkt — for utstyr, reservedeler og hjelp når det haster.
            </p>
          </Reveal>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-ink/15 mt-14 border border-ink/15">
            {STATS.map((s, i) => (
              <Reveal key={s.label} delay={i * 0.08} className="bg-paper">
                <div className="p-6 sm:p-8" data-testid={`stat-${i}`}>
                  <div className="font-oswald text-4xl sm:text-6xl text-ink leading-none">{s.value}</div>
                  <div className="font-oswald uppercase text-xs tracking-widest text-ink/50 mt-3">{s.label}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
